var shpCustom = {

	cartItemsCountPanel: ".shpCartCount",
	cartItemsValuePanel: ".shpCartValue",

	shpProduct: null,
	shpCart: null,
	shpCartAdditional: null,
	reloadEnabled: false,
	twoLevelZoom: false,
	
	baseURL: '',
	cookieInfoPeriod: 0,
	newsletterDismiss: 0,
	newsletterSubmit: 0,
	
//##################################################################################################
//	INITIALIZATION
//##################################################################################################
	init: function() {
		shpCustom.baseURL 					= $('meta[name="shpBaseDir"]').attr('content');
		shpCustom.cookieInfoPeriod 	= $('meta[name="shpCookieInfoPeriod"]').attr('content');
		shpCustom.newsletterDismiss = $('meta[name="shpNewsletterDismiss"]').attr('content');
		shpCustom.newsletterSubmit 	= $('meta[name="shpNewsletterSubmit"]').attr('content');
		
	//-------------------------------------------------------------------------------------------------	
	//	cart
	//-------------------------------------------------------------------------------------------------	
		$('.shpAdd2CartButton').on('click', function(event) {
			event.preventDefault();
			shpCustom.cartItemAdd(this);
		});
		$('.shpAdd2CartButton').removeClass('d-none');

		shpCustom.initCartEvents();

		if (sessionStorage.getItem("shpShowCart")) {
			setTimeout(shpCustom.showCart(),1000);
		}

		
	//-------------------------------------------------------------------------------------------------	
	//	misc
	//-------------------------------------------------------------------------------------------------	
		// blog, collections
		$('#shpLoadItemsList').on('click', function(event) {
			event.preventDefault();
			shpCustom.loadItemsList($(this).attr("href"));
		});
		
		// magic with open modals, change href
		this.hrefToModal();
		$('button[data-target]').on('click', function() {
			location.href = $(this).data('target');
		});
		$('#shpCustomShowInfo').on('hidden.bs.modal', function(){ 
			$(this).find(".modal-title").text('');
			$(this).find(".modal-body").html('');	
		})

		// scroll2Element
		$('[data-scroll2element]').on('click', function(event) {
			event.preventDefault();
			shpCustom.scrollToElement($(this).data('scroll2element'));
		});

		// copy current URL to clipboard
		// show info about it
		$('[data-clipboard-share]').on('click', function(event) {
			event.preventDefault();
			let copyText = location.href;
			if (copyText) {
				 navigator.clipboard.writeText(copyText);
				 shpCustom.showInfo($(this).data('clipboard-share'), copyText);
			}
		});
		
		// checkbox group with only one ON
		$('[data-checkbox_group]').on('change', function(event) {
			event.preventDefault();
			shpCustom.chceckboxGroup($(this));
		});

	//-------------------------------------------------------------------------------------------------	
	// check newsletter box
	//-------------------------------------------------------------------------------------------------	
		if (!shpCustom.getCookie('newsletter_box')) {
			$('#shpNewsletterModalPanel').on('hidden.bs.modal', function(event) {
				if (shpCustom.newsletterDismiss>0) {
					shpCustom.setCookie('newsletter_box',1, shpCustom.newsletterDismiss);	// close Newsletter window for X days
				} else {
					shpCustom.setCookie('newsletter_box',1);			// close Newsletter window for current session
				}
			})
			setTimeout(function(){
				$('#shpNewsletterModalPanel').modal('show');
			}, 2000);
		}	
		$('.shpCustomNewsletterFormDiv form').on('submit', function() {	// if submited any newsletter form
			if (shpCustom.newsletterSubmit>0) {
				shpCustom.setCookie('newsletter_box',1, shpCustom.newsletterSubmit);	// close Newsletter window for X days
			} else {
				shpCustom.setCookie('newsletter_box',1);			// close Newsletter window for current session
			}
		}); 
		
		
	//-------------------------------------------------------------------------------------------------	
	// check Cookie information
	//-------------------------------------------------------------------------------------------------	
		if (!shpCustom.getCookie('cookies_box')) {
			$('#shpCookiesModalPanel button.accept').on('click', function() {
				$('#shpCookiesModalPanel').addClass('d-none');
				if (shpCustom.cookieInfoPeriod>0) {
					shpCustom.setCookie('cookies_box',1, shpCustom.cookieInfoPeriod);	// close Cookie information for X days
				} else {
					shpCustom.setCookie('cookies_box',1);			// close Cookie information for current session
				}
			});
			$('#shpCookiesModalPanel').removeClass('d-none');
		}
		

	//-------------------------------------------------------------------------------------------------	
	//	customer section
	//-------------------------------------------------------------------------------------------------	
		//if ($('body.login-page').length>0) {
			// login / password reset-start
			$('.shpLoginFormToggle').on('click', function(event) {
				event.preventDefault();
				$('.login-form').toggle();
			});
		//}
		
		if ($('body.addresses-page').length>0) {
			// addresses
			// show/hide address form
			$('[data-target_item_form_id]').on('click', function(event) {
				event.preventDefault();
				$('[data-item_form_id]').hide();
				let form_id = $(this).data('target_item_form_id');
				$('[data-item_form_id='+form_id+']').show();
			});
			// confirm address removal
			$('#shpAddressRemoveConfirmation').on('show.bs.modal', function (event) {
				var button = $(event.relatedTarget);
				$(this).find('form').attr('action',button.data('target'))
			});
			$('#shpAddressRemoveConfirmation').on('hidden.bs.modal', function (event) {
				$(this).find('form').attr('action','#');
			});

			$('select[name="address[country]"]').each(function () {
				shpCustom.setSelectValue($(this));
			})
		}

	//-------------------------------------------------------------------------------------------------	
	//	collection page / product list
	//-------------------------------------------------------------------------------------------------	
		if ($('body.collection-page').length>0) {
			
			// tag-filters
			$('#tag-filters button.apply').on('click', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagFilters();
			});
			
			$('#tag-filters button.reset').on('click', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagFilters(true);
			});

			if ($('#tag-filters').data('start_mode') == 'background') {
				$('#tag-filters input[type=checkbox], input[type=radio]').on('click', function(event) {
					shpCustom.applyTagFilters();
				});
			}
			
			shpCustom.initApplyFilters();

		}
		
	//-------------------------------------------------------------------------------------------------	
	//	search page
	//-------------------------------------------------------------------------------------------------	
		if ($('body.search-page').length>0) {
			
			let query = shpCustom.getUrlParameter('q');
			if (query) {
				jQuery.each(query.split(/[\+\,\;]/), function(index, element) {
					//console.log('|'+element+'|');
					$('#tag-filters').find('input[type=checkbox][data-name="'+element.trim()+'"]').prop("checked",true);
				});
			}			
			
			// filters
			$('#tag-filters button.apply').on('click', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagSearchFilters();
			});
			
			$('#tag-filters button.reset').on('click', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagSearchFilters(true);
			});
			
			shpCustom.initApplyFilters();

		}
		
	//-------------------------------------------------------------------------------------------------	
	//	product page
	//-------------------------------------------------------------------------------------------------	
		if ($('body.product-page').length>0) {
			
			shpCustom.reloadEnabled = true;
			let product_handle = $('#product-object').data('handle');
			jQuery.getJSON("/products/"+product_handle+".js", function(product) {
				shpCustom.shpProduct = product;
				shpCustom.add2Visited(product);
				// get selected Variant ID
				shpCustom.shpProduct.selected_variant_id = $('#product-object').data('variant');
				jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
					if (element.id == shpCustom.shpProduct.selected_variant_id) {
						// get selected Variant position
						shpCustom.shpProduct.selected_variant_index = index;
					}
				});
				$('body').trigger('updateProductInfo');
			});

			// productgroup selector (SWATCH)
			$('input[name=productgroup]').on('change', function(event) {
				//event.preventDefault();
				//event.stopPropagation();
				let target = $(this).val();
				if (target && target != '#') {
					window.location.href = shpCustom.baseURL + $(this).val();
				}
			});
			
			// many variants selectors (based on CHECKBOXES)
			$('input.variantSelector').on('click', function() {
				let cartForm = $(this).parents('form');
				let newVariantID = $(this).val();
				let currentID = $(this).attr('id');
				
				$(cartForm).find('input.variantSelector').each(function () {
					if ($(this).val()==newVariantID && $(this).attr('id') != currentID) {
						$(this).prop('checked',true);
					}
				})
				jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
					if (element.id == newVariantID) {
						shpCustom.updateVariantInfo(element);
						
						// update URL (without reloading)
						history.pushState('page', shpCustom.shpProduct.title, $('#product-object').data('baseurl') + '?variant=' + newVariantID);
					}
				});				
			});
			
			// one variant selector (based on SELECT)
			$('select.variantSelector').on('change', function() {
				let cartForm = $(this).parents('form');
				let newVariantID = $(this).find('option:selected').val();
				let currentID = $(this).attr('id');
				
				jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
					if (element.id == newVariantID) {
						shpCustom.updateVariantInfo(element);
						
						// update URL (without reloading)
						history.pushState('page', shpCustom.shpProduct.title, $('#product-object').data('baseurl') + '?variant=' + newVariantID);
					}
				});
			});

		};
		
	//-------------------------------------------------------------------------------------------------	
	//	video blocks
	//-------------------------------------------------------------------------------------------------	
		var w = window.innerWidth
						|| document.documentElement.clientWidth
						|| document.body.clientWidth;
		$(".video-block").each(function () {
			let video_block = $(this);
			$(this).find("video").each(function () {
				// change SRC for mobile
				if ($(this).children('source').data('mobile') != undefined && w <= 768) {
					$(this).children('source').attr('src', $(this).children('source').data('mobile'));
					$(video_block).find("video")[0].load();
				}
			});
		});

		//-------------------------------------------------------------------------------------------------	
		//	simple variant switch
		//-------------------------------------------------------------------------------------------------	
		$('[data-variant_simple_selector]').on('click', function(event) {
			//event.preventDefault();
			//event.stopPropagation();
			shpCustom.varaintSimpleSwitch(this);
		});
	
		//-------------------------------------------------------------------------------------------------	
		//	ui-groups
		//	(a group of checkboxes controlling hidden inputs)
		//-------------------------------------------------------------------------------------------------	
		$('[data-ui_group]').on('change', function(event) {	
			event.preventDefault();
			shpCustom.uiGroupRun(this);
		});

		window.shpCustom = shpCustom;
	},
	
//##################################################################################################
//	module functions
//##################################################################################################
//-------------------------------------------------------------------------------------------------	
//	cookies
//-------------------------------------------------------------------------------------------------	
	setCookie: function (cname, cvalue) {
		var expires = "";
		var path = "path=/";
		if (arguments[2]) {
			var d = new Date();
			d.setTime(d.getTime() + (arguments[2]*24*60*60*1000));
			expires = "expires="+d.toGMTString()+"; ";
		}
		document.cookie = "SHP_" + cname + "=" + cvalue + "; " + expires + path;
	},
	
	getCookie: function (cname) {
		var name = "SHP_" + cname + "=";
		var ca = document.cookie.split(';');
		for(var i=0; i<ca.length; i++) {
			var c = ca[i].trim();
			if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
		}
		return "";
	},
	
	
//-------------------------------------------------------------------------------------------------	
//	misc
//-------------------------------------------------------------------------------------------------	

	// change a.href with href #modal_id (added in Theme Customization) to button witch opens that modal
	hrefToModal: function() {
		$('.modal').each(function () {
			let id = $(this).attr("id");
			$("a[href='#"+id+"']").each(function () {
				$(this).attr('href','#');
				$(this).attr('data-bs-toggle','modal').data('bs-toggle','modal');
				$(this).attr('data-bs-target','#'+id).data('bs-target','#'+id);
			});
		});
	},
	
	/**
	 *  @brief Loads next page of items. Should be bined to <a href="url2load"> button
	 *  
	 *  @param [in] url2load 					url to load next page (href)
	 *  @param [in] successCallback 	callback function
	 *  @param [in] clearContainer 		flag: clear Items container before load?
	 *  
	 *  @details 
	 *  	- items are placed in #shpItemsList2Load-container (next are append to old one)
	 *  	- panel with loading - #shpItemsList2Load-count (old panel content is replaced by next)
	 *  
	 */
	loadItemsList: function(url2load) {
		$('body').addClass('shpItemsLoading');
		let successCallback = (arguments[1]) ? arguments[1] : "";
		let clearContainer = (arguments[2]) ? arguments[2] : "";
		$.ajax({
			url: url2load,
			type: 'GET'
		}).done(function(data) {
			// 1. load itemsList into page
			if (clearContainer) {
				$('#shpItemsList2Load-container').html($(data).find('#shpItemsList2Load-container').html());
			} else {
				$('#shpItemsList2Load-container').append($(data).find('#shpItemsList2Load-container').html());
			}
			// 2. refresh itemsListCount
			$('#shpItemsList2Load-count').html($(data).find('#shpItemsList2Load-count').html());

			// 3. attach loadItemsList method
			$('#shpLoadItemsList').on('click', function(event) {
				event.preventDefault();
				shpCustom.loadItemsList($(this).attr("href"), successCallback);
			});
			
			// 4. run callback
			if (typeof successCallback !== 'function') {
				successCallback = false;
			}
			if (successCallback) {
				successCallback(data);
			}
			
			// 5. refresh shpAdd2CartButton click event (in case new buttons)
			$('.shpAdd2CartButton').each(function() {
				$(this).off('click');
			});
			$('.shpAdd2CartButton').on('click', function(event) {
				event.preventDefault();
				shpCustom.cartItemAdd(this);
			});
			$('.shpAdd2CartButton').removeClass('d-none');
			
			$('body').removeClass('shpItemsLoading');
			$('body').trigger('loadItemsList');
		});
	},
		
	getUrlParameter: function(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] === sParam) {
				return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
			}
    }
    return false;
	},
	
	setSelectValue: function(selectElement) {
		let selectValue = $(selectElement).data('default');
		if (selectValue) {
			$(selectElement).find('option').each(function() {
				if ($(this).text() == selectValue) {
					$(this).prop('selected',true);
					return false;
				}
			});
		}
	},
	
	showInfo: function (infoTitle, infoText) {
		if ($('#shpCustomShowInfo').length>0) {
			let infoModal = $('#shpCustomShowInfo');
			$(infoModal).find(".modal-title").text(infoTitle);
			$(infoModal).find(".modal-body").html(infoText);	
			$(infoModal).modal('show');
		} else {
			alert(infoTitle + ':' + String.fromCharCode(13,10) + infoText);
		}
	},
	
	scrollToElement: function(elSelector) {
		if ($(elSelector).length>0) {
			let position = $(elSelector).position();
			let headerOffset = ($("header").length > 0 ? $("header").height() : 0);
			let marginHeight = 5;
			
			position = parseInt(position.top ) - headerOffset - marginHeight;
			document.body.scrollTop = position; // For Safari
			document.documentElement.scrollTop = position; // For Chrome, Firefox, IE and Opera
		}
	},
	
	uiGroupRun: function(element) {		
		if ($('[data-ui_group="'+  $(element).data('ui_group') +'"]').length>1) {
			let mainElement = $('[data-ui="'+  $(element).data('ui_group') +'"]');
			let mainValue = ($(element).prop('checked') ? $(element).val() : '');
			if ($(mainElement).length > 0) {
				$(mainElement).val(mainValue);
				$('[data-ui_group="'+  $(element).data('ui_group') +'"]').each(function() {
					$(this).prop('checked', ($(this).val() == mainValue));
				});
				$(mainElement).change();
			}
		}
	},

	gotoURL: function(element) {
		location.href = encodeURI($(element).data('url'));
	},

//-------------------------------------------------------------------------------------------------	
//	collection page / product list
//-------------------------------------------------------------------------------------------------	

	initApplyFilters: function() {
		$('#filters button.apply').on('click', function(event) {
			event.preventDefault();
			shpCustom.reloadEnabled = true;
			shpCustom.applyFilters();
		});
		
		$('#filters button.reset').on('click', function(event) {
			event.preventDefault();
			shpCustom.reloadEnabled = true;
			shpCustom.applyFilters(true);
		});

		if ($('#filters').data('start_mode') == 'background') {
			$('#filters input[type=checkbox], input[type=radio]').on('change', function(event) {
				event.preventDefault();
				shpCustom.applyFilters();
			});
		}
	},

	/**
	 *  @brief function to assign submit (read filter checkboxes, send request and get response)
	 */
	applyFilters: function() {

		let filtersPanel = $('#filters');
		let targetUrl = '';
		
		if (filtersPanel.data('collection_url')) {		

			let collectionURL = shpCustom.baseURL + filtersPanel.data('collection_url') + '/';
			let filtersList = [];

			let paramsURL = filtersPanel.data('url_params');
			if (paramsURL) {
				filtersList.push(paramsURL);
			}
			

			if (arguments[0] !== true) {// true => reset filters
				// filters are defined by checkbox inside filtersPanel
				filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
					if ($(this).attr('name')!='sort_by' && $(this).prop('checked') && $(this).prop('disabled')==false) {
						filtersList.push($(this).attr('name')+'='+encodeURI($(this).val()));
					}
				});
			} else {
				filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
					$(this).prop('checked', false);
				});
			}

			if (filtersPanel.data('collection_sortby')) {
				// sorting is defined elsewhere
				filtersList.push('sort_by='+filtersPanel.data('collection_sortby'));
			} else {
				// sorting is defined by checkbox inside filtersPanel
				if (arguments[0] !== true) {// true => reset sorting
					let sort_order = filtersPanel.find('input[name=sort_by]:checked').val();
					if (sort_order) {
						filtersList.push('sort_by='+sort_order);
					}
				}
			}	
			targetUrl = collectionURL
			if (filtersList.length > 0) {
				targetUrl = targetUrl + '?' + filtersList.join('&');
			}


			if (filtersPanel.data('run_mode') == 'reload' && shpCustom.reloadEnabled) {
				window.location.href = targetUrl;
			} else if (filtersPanel.data('run_mode') == 'ajax') {
				// update URL (without reloading)
				history.pushState('page', 'Collection page', targetUrl);

				// update filters panel 
				$.ajax({
					url: targetUrl + ( targetUrl == collectionURL ? '?' : '&') + 'sections=collection-filters',
					type: 'GET'
				}).done(function(data) {
					// 1. load into page elements signed data-filterItem2load='element_index'
					$(data['collection-filters']).find('[data-filter_item2load]').each(function() {
						if ($(this).data('filter_item2load')) {
							$('#filters').find('[data-filter_item2load="' + $(this).data('filter_item2load') + '"]').html($(this).html());
							$('#filters').find('[data-filter_item2load="' + $(this).data('filter_item2load') + '"]').attr('class', $(this).attr('class'));
						}
					});
					shpCustom.initApplyFilters()
				});

				// load items list
				shpCustom.loadItemsList(targetUrl, false, true);
			}
		}
		return targetUrl;
	},

	/**
	 *  @brief function to assign submit (read tag checkboxes and send request)
	 */
	applyTagFilters: function() {
		let filtersPanel = $('#tag-filters');
		let targetUrl = '';
		
		if (filtersPanel.data('collection_url')) {		

			let collectionURL = shpCustom.baseURL + filtersPanel.data('collection_url') + '/';
			let filtersList = [];
			let sort_url = '';
			
			if (arguments[0] !== true) {// true => reset filters
				let externalFilters = false;
			
				let filterDataset = filtersPanel.data();
				//console.log(filterDataset);
				if (filterDataset != undefined) {
					for (const property in filterDataset) {
						if (property.substring(0,17) == 'collection_filter') {
							// filters are defined elsewhere and kept in filtersPanel.data()
							externalFilters = true;
							if (filterDataset[property] != '') {
								filtersList.push(filterDataset[property]);
							}
						}	
					}
				}
				
				if (!externalFilters) {
					// filters are defined by checkbox inside filtersPanel
					filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
						if ($(this).attr('name')!='sort_by' && $(this).prop('checked') && $(this).prop('disabled')==false) {
							filtersList.push($(this).val());
						}
					});
				}
			} else {
				filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
					$(this).prop('checked', false);
				});
			}

			if (filtersPanel.data('collection_sortby')) {
				// sorting is defined elsewhere
				sort_url = '?sort_by='+filtersPanel.data('collection_sortby');
			} else {
				// sorting is defined by checkbox inside filtersPanel
				if (arguments[0] !== true) {// true => reset sorting
					let sort_order = filtersPanel.find('input[name=sort_by]:checked').val();
					if (sort_order) {
						sort_url = '?sort_by='+sort_order;
					}
				}
			}
		
			//console.log(collectionURL + filtersList.join('+') + sort_url);
			targetUrl = collectionURL + filtersList.join('+') + sort_url;

			if (filtersPanel.data('run_mode') == 'reload' && shpCustom.reloadEnabled) {
				window.location.href = targetUrl;
			} else if (filtersPanel.data('run_mode') == 'ajax') {
				// update URL (without reloading)
				history.pushState('page', 'Collection page', targetUrl);
				shpCustom.loadItemsList(targetUrl, false, true);
			}
		}
		return targetUrl;
	},

//-------------------------------------------------------------------------------------------------	
//	search page
//-------------------------------------------------------------------------------------------------	

	applyTagSearchFilters: function() {
		let filtersPanel = $('#tag-filters');
		let targetUrl = '';
		
		if (filtersPanel.data('collection_url')) {		

			let searchURL = shpCustom.baseURL + filtersPanel.data('collection_url');
			let paramsList = [];

			let sort_url = '';
			if (filtersPanel.data('collection_sortby')) {
				// sorting is defined elsewhere
				sort_url = 'sort_by='+filtersPanel.data('collection_sortby').trim();
			} else {
				// sorting is defined by checkbox inside filtersPanel
				if (arguments[0] !== true) {// true => reset sorting
					let sort_order = filtersPanel.find('input[name=sort_by]:checked').val();
					if (sort_order) {
						sort_url = 'sort_by='+sort_order.trim();
					}
				}
			}
			if (sort_url) {
				paramsList.push(sort_url);
			}
			
			if (filtersPanel.data('search_type')) {
				paramsList.push('type='+filtersPanel.data('search_type').trim());
			}
			
			let filtersList = [];
			if (filtersPanel.data('search_q')) {
				filtersList.push(filtersPanel.data('search_q').trim());
			}
			if (arguments[0] !== true) {// true => reset filters (but only TAGS)
				
				let externalFilters = false;			
				let filterDataset = filtersPanel.data();
				//console.log(filterDataset);
				if (filterDataset != undefined) {
					for (const property in filterDataset) {
						if (property.substring(0,17) == 'collection_filter') {
							// filters are defined elsewhere and kept in filtersPanel.data()
							externalFilters = true;
							if (filterDataset[property] != '') {
								filtersList.push(filterDataset[property]);
							}
						}	
					}
				}
				
				if (!externalFilters) {
					// filters are defined by checkbox inside filtersPanel
					filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
						if ($(this).attr('name')!='sort_by' && $(this).prop('checked') && $(this).prop('disabled')==false) {
							filtersList.push($(this).val());
						}
					});
				}
			} else {
				filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
					$(this).prop('checked', false);
				});
			}
			paramsList.push('q=' + filtersList.join('+'));
			
			targetUrl = searchURL + '?' + paramsList.join('&')

			if (filtersPanel.data('run_mode') == 'reload' && shpCustom.reloadEnabled) {
				window.location.href = targetUrl;
			} else if (filtersPanel.data('run_mode') == 'ajax') {
				// update URL (without reloading)
				history.pushState('page', 'Search result', targetUrl);
				shpCustom.loadItemsList(targetUrl, false, true);
			}
		}
		return targetUrl;
	},
			
//-------------------------------------------------------------------------------------------------	
//	product
//-------------------------------------------------------------------------------------------------	
	/**
	 * @brief	switching variants implemented as controlling the visibility of already prepared elements
	 *				suitable for simple elements, panels
	 */
	varaintSimpleSwitch: function(element) {
		let container = $(element).parents('[data-variant_simple_container]');
		let variant_id = $(element).data('variant_id');

		if (container.length>0 && variant_id != undefined) {
			$(container).find('[data-variant_simple_selector]').removeClass('active');
			$(element).addClass('active');

			$(container).find('[data-selected_variant_id]').addClass('d-none');
			$(container).find('[data-selected_variant_id='+variant_id+']').removeClass('d-none');

			jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
				if (element.id == variant_id) {
					if (element.available) {
						$(container).find('[data-selected_variant_notavailable]').addClass('d-none');
						$(container).find('[data-selected_variant_available]').removeClass('d-none');
					} else {
						$(container).find('[data-selected_variant_available]').addClass('d-none');
						$(container).find('[data-selected_variant_notavailable]').removeClass('d-none');
					}
				}
			});
		}
	},

	/**
	 * @brief	reloading to variant page 
	 *				variant idetyfication based on options list
	 */
	reload2Variant: function (option1, option2, option3) {			
		
		let goodID_123 = null;	
		let goodID_12 = null;	
		
		let firstOption1ID = null;
		let firstOption2ID = null;
		let firstOption3ID = null;

		let selectedVariant = shpCustom.shpProduct.variants[shpCustom.shpProduct.selected_variant_index];
		jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
			if (!firstOption1ID && element.options[0] == option1) {
				firstOption1ID = element.id;
			}
			if (!firstOption2ID && element.options[1] == option2) {
				firstOption2ID = element.id;
			}
			if (!firstOption3ID && element.options[2] == option3) {
				firstOption3ID = element.id;
			}

			if (!goodID_12 && element.options[0] == option1 && element.options[1] == option2) {
				goodID_12 = element.id;
			}
			if (!goodID_123 && element.options[0] == option1 && element.options[1] == option2 && element.options[2] == option3) {
				goodID_123 = element.id;
			}
		});
		
		// console.log('goodID_123' + goodID_123);
		// console.log('goodID_12' + goodID_12);
		// console.log('firstOption1ID' + firstOption1ID);
		// console.log('firstOption2ID' + firstOption2ID);
		// console.log('firstOption3ID' + firstOption3ID);
		
		let goodID = ( goodID_123 ? goodID_123 : goodID_12);
		
		if (!goodID) {
			if (firstOption1ID) {
				goodID = firstOption1ID;
			} else if (firstOption2ID) {
				goodID = firstOption2ID;
			} else {
				goodID = firstOption3ID;
			}
		}			
		if (goodID) {
			//if (shpCustom.reloadEnabled) {
				window.location.href = shpCustom.baseURL + shpCustom.shpProduct.url + '?variant=' + goodID;
			//}
		}
	},

	/**
	 *  @brief from changed option calculate new selected Variant
	 *  
	 *  @param [in] optionID		option.position
	 *  @param [in] optionValue option value for Variant
	 *  @return slected Variant Object
	 *  
	 */
	setNewVariantByOptions: function(optionID, optionValue) {
		if (shpCustom.shpProduct.selected_variant_index == undefined) {
			shpCustom.shpProduct.selected_variant_index = 0;
		}

		let newVariant = false;
		let currentVariant = shpCustom.shpProduct.variants[shpCustom.shpProduct.selected_variant_index];
		let currentFeatures = {
			"option1": null, "option2": null, "option3": null
		};
		if (currentVariant) {
			currentFeatures = {
				"option1": currentVariant.option1,
				"option2": currentVariant.option2,
				"option3": currentVariant.option3
			};
		}
		// get clone of currentFeatures but with changed option
		let newFeatures = Object.assign({}, currentFeatures);
		newFeatures[optionID] = optionValue;
		
		jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
			if (element.option1 == newFeatures.option1 && element.option2 == newFeatures.option2 && element.option3 == newFeatures.option3) {
				newVariant = Object.assign({}, element);
				newVariant['index'] = index;
			}
		});
		
		shpCustom.updateVariantInfo(newVariant);
	},

	/**
	 *  @brief load data of new Variant into HTML Elements (JS OR Section Rendering API)
	 *  
	 *  @param [in] newVariant 	new variant data
	 */
	updateVariantInfo: function(newVariant) {
		const mode = 'default';
		
		if (newVariant != false) {
			if (mode == 'load') { // loading newVariant using Section AJAX API
				$.ajax({
					url: $('#product-object').data('baseurl') + '?sections=main-product&variant=' + newVariant.id,
					type: 'GET'
				}).done(function(data) {
					// 1. load html into page
					$('#shpProductVariant-container').html($(data['main-product']).find('#shpProductVariant-container').html());
				});

			} else { // loading a newVariant by updating predefined elements based on data in the newVariant object
			
				// price
				let moneyFormat = shpTheme.money.moneyFormat+"";
				$('#product-object .product-standard-price').html(moneyFormat.replace('{{amount}}', numeral(newVariant.price/100).format('0,0.00')));
				if (newVariant.compare_at_price > newVariant.price) {
					$('#product-object .product-compare-price').html(moneyFormat.replace('{{amount}}', numeral(newVariant.compare_at_price/100).format('0,0.00')));
				} else {
					$('#product-object .product-compare-price').html('');
				}
				
				// variant ID
				$('#product-object').attr('data-variant',newVariant.id);
				$('#product-object input[name=id]').val(newVariant.id);
				
				// AddToCart buttons
				let Add2Cart = $('#product-object .shpAdd2CartButton');
				if (newVariant.available) {
					$(Add2Cart).prop("disabled",false);
					$(Add2Cart).find('[data-unavailable_label]').hide();
					$(Add2Cart).find('[data-add2cart_label]').show();
					//$(Add2Cart).find('[data-add2cart_label]').html(shpTheme.strings.addToCart);
				} else {
					$(Add2Cart).prop("disabled",true);
					$(Add2Cart).find('[data-add2cart_label]').hide();
					$(Add2Cart).find('[data-unavailable_label]').show();
					//$(Add2Cart).find('[data-add2cart_label]').html(shpTheme.strings.unavailableProduct);
				}
				
				// image - scroll to variant image
				if (newVariant.featured_image && $('.product-carousel').length>0) {
					if ($('.product-carousel.flickity-enabled').length>0) {
					// Flickity 	
						$('.product-carousel .carousel-cell').each(function (index) {
							if (newVariant.featured_image.id == $(this).data('src_id')) {
								$('.product-carousel').flickity( 'select', index, false, true );
							}
						});
					} else if ($('.product-carousel.slick-initialized').length>0) {
					// Slick
						$('.product-carousel .slick-slide').not('.slick-cloned').each(function () {
							if (newVariant.featured_image.id == $(this).data('src_id')) {
								$('.product-carousel').slick('slickGoTo',$(this).data('slick-index'), true);
							}
						});
					}
				}
			}
			shpCustom.shpProduct.selected_variant_index = newVariant.index;

			// update URL (without reloading)
			history.pushState('page', shpCustom.shpProduct.title, $('#product-object').data('baseurl') + '?variant=' + newVariant.id);

			$('body').trigger('updateVariantInfo');

		} else {
			shpCustom.showInfo(shpTheme.strings.unknownVariantTitle, shpTheme.strings.unknownVariantMessage);
		}
	},

	add2Visited: function(product) {
		const productData = {
			productID: product.id,
			title: product.title,
			handle: product.handle
		};

		const productList = [];
		let jsonResp, jsonRespArr, jsonRespArrStr;
		const numberOfProducts = 20;
	
		productList.push(productData);
		const currProductPageTitle = productData.title;
		const productDataString = JSON.stringify(productList);
		const localData = localStorage.getItem("recentlyViewedProduct");
	
	  if (localData === null) {
			localStorage.setItem("recentlyViewedProduct", productDataString);
		} else if (localData) {
			const oldProductData = localStorage.getItem("recentlyViewedProduct");
			const countProductData = (oldProductData.match(/productID/g) || []).length;
			const sameProduct = oldProductData.includes(currProductPageTitle);
	
			if (countProductData < numberOfProducts && sameProduct == false) {
				jsonResp = JSON.parse(oldProductData);
				jsonRespArr = jsonResp.concat(productList);
				jsonRespArrStr = JSON.stringify(jsonRespArr);
				localStorage.setItem("recentlyViewedProduct", jsonRespArrStr);
			} else if (countProductData >= numberOfProducts && sameProduct == false) {
				jsonResp = JSON.parse(oldProductData);
				jsonResp.shift();
				jsonRespArr = jsonResp.concat(productList);
				jsonRespArr = JSON.stringify(jsonRespArr);
				localStorage.setItem("recentlyViewedProduct", jsonRespArr);
			}
		}
	},


//-------------------------------------------------------------------------------------------------	
//	cart
//-------------------------------------------------------------------------------------------------	
	/**
	 * @brief	initialization of the operation of the main elements of the shopping cart interface
	 */
	initCartEvents: function() {
		// cart lines
		$('[data-cart-item-quantity_group] [data-type=minus]').on('click', function(event) {
			event.preventDefault();
			shpCustom.setQuantity(this, -1);
		});
		$('[data-cart-item-quantity_group] [data-type=plus]').on('click', function(event) {
			event.preventDefault();
			shpCustom.setQuantity(this, 1);
		});
		$('[data-cart-item-quantity_group] [data-type=remove]').on('click', function(event) {
			event.preventDefault();
			shpCustom.cartItemRemove(this);
		});
		$('[data-cart-item-quantity_group] [data-cart-item-quantity]').on('change', function(event) {
			event.preventDefault();
			let productSection = $(this).parents('[data-cart-item]');
			shpCustom.cartItemUpdate(productSection.data('cart-item-key'), $(this).val());		
		});
		$('[data-cart-item-selling_plan]').on('change', function(event) {
			event.preventDefault();
			let productSection = $(this).parents('[data-cart-item]');
			shpCustom.cartItemUpdate(productSection.data('cart-item-key'), null, $(this).val());		
		});

		// cart properties
		$('[data-cart-attribute]').on('change', function(event) {
			event.preventDefault();
			shpCustom.cartAttributeUpdate(this);
		});
		$('[data-cart-note]').on('change', function(event) {
			event.preventDefault();
			shpCustom.cartUpdate($(this).val(), null);
		});
	},

	showCart: function() {
		$('body').trigger('shpShowCart');
		sessionStorage.removeItem("shpShowCart");
	},

	getCart: function() {
		let silentMode = (arguments[0] === true);
		jQuery.getJSON("/cart.js", function(cart) {
			shpCustom.shpCart = cart;
			shpCustom.updateCartInfo();
			$('.shpProcessCartWait').hide();
			if (!silentMode) {
				shpCustom.showCart();
			}
		});
	},

	updateCartInfo: function() {
		
		let moneyFormat = shpTheme.money.moneyFormat+"";
		
		// update summary data
		$(shpCustom.cartItemsCountPanel).text(shpCustom.shpCart.item_count);
		$(shpCustom.cartItemsValuePanel).html(moneyFormat.replace('{{amount}}',numeral(shpCustom.shpCart.total_price/100).format('0,0.00')));

		$('[data-cart-subtotal]').html(moneyFormat.replace('{{amount}}',numeral(shpCustom.shpCart.total_price/100).format('0,0.00')));
		$('[data-cart-subtotal]').attr('data-cart-subtotal', numeral(shpCustom.shpCart.total_price/100).format("0.00"));
		if (shpCustom.shpCart.item_count==0) {
			$('.shpCartContent').addClass('empty');
		} else {
			$('.shpCartContent').removeClass('empty');
		}
		
		// update mini-cart panel
		let current_lines = [];
		if (Array.isArray(shpCustom.shpCart.items)) {
			$.each(shpCustom.shpCart.items, function( index, item ) {
				current_lines.push(item.variant_id);
				let cartLine = $('[data-cart-item-vid="'+item.variant_id+'"]');
				if ($(cartLine).length>0) {
					$(cartLine).find('[data-cart-item-quantity]').attr('data-cart-item-quantity',item.quantity);
					$(cartLine).find('[data-cart-item-quantity]').val(item.quantity);
					$(cartLine).find('[data-cart-item-properties]').html(item.properties);
				} else {
					shpCustom.newCartLine(item);
				}
			});
		}
		$('[data-cart-item]').not('.shpCartLineTemplate').each(function() {
			if (current_lines.indexOf($(this).data('cart-item-vid')) === -1) {
				$(this).remove();
			}
		});

		// attributes
		$('[data-cart-attribute]').each(function() {
			$(this).data('disable_events', true);

			let cartAttribute = $(this).data('cart-attribute');
			let attrValue = shpCustom.shpCart.attributes[cartAttribute];
			//console.log([cartAttribute,attrValue]);
			if ($(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio') {
				$(this).prop('checked', ($(this).val() == attrValue));
			} else {
				$(this).val(attrValue);
			}

			// looking for control checkbox(es)
			if ($(this).data('ui') != undefined) {
				let uiGroup = $('[data-ui_group='+$(this).data('ui')+']');
				// the found input attribute has its own control checkbox(es)
				if (uiGroup.length == 1) {
					// only one => checked if there is attrValue != ''
					if (((typeof attrValue !== 'undefined' && attrValue != "") && uiGroup.prop('checked')==false) || 
							((typeof attrValue === 'undefined' || attrValue == "") && uiGroup.prop('checked')==true)) {
						$(this).attr('data-value', attrValue);
						uiGroup.click();
					}
				} else if (uiGroup.length > 1) {
					// many => checked if there is attrValue == checkboxValue
					$(uiGroup).each(function() {
						$(this).prop('checked', ($(this).val() == attrValue));
					});
				}
			}

			$(this).data('disable_events', false);
		});

		// Update LoyaltyLion points
		let pointsEl = document.querySelector('[data-lion-points-for]');
		if (pointsEl) {
		  pointsEl.setAttribute('data-lion-points-for', shpCustom.shpCart.total_price);
		  if (window.loyaltylion && window.loyaltylion.ui && typeof window.loyaltylion.ui.refresh === 'function') {
		    window.loyaltylion.ui.refresh();
		  }
		}

		$('body').trigger('updateCartInfo');
	},

	setQuantity: function(element, step) {
		let sectionContainer = $(element).parents('[data-cart-item-quantity_group]');
		if (!$(sectionContainer).hasClass('section-disabled')) {
			let sectionInput = $(sectionContainer).find('input[name="quantity"]');
			let sectionlabel = $(sectionContainer).find('[data-cart-item-quantity_label]');
			let productSection = $(element).parents('[data-cart-item]');
			
			let result = $(sectionInput).val()*1 + step*1;
			if (result*1 <= 0) {
				result = 1;
			}
			$(sectionInput).val(result);
			
			if (result<=1) {
				$(sectionContainer).find('[data-type=minus]').prop("disabled", true);
			}	else {
				$(sectionContainer).find('[data-type=minus]').prop("disabled", false);
			}
			shpCustom.cartItemUpdate(productSection.data('cart-item-vid'), result, productSection.data('cart-item-title'));
			
			
			if (result < 10) {
				result = "0" + result;
			}
			$(sectionlabel).text(result);
			
		}
	},
	
	cartItemRemove: function(element) {
		let productSection = $(element).parents('[data-cart-item]');
		shpCustom.cartItemUpdate(productSection.data('cart-item-vid'), 0, productSection.data('cart-item-title'));		
	},

	cartItemAdd: function(element) {
		let variant_id, variant_quantity, selling_plan, do_reload; 
		let properties = {};
		
		if ($(element).data('variant_id') != undefined) {
			// all data are attached to AddToBag button (product list case)
			variant_id = $(element).data('variant_id');
			variant_quantity = ($(element).data('quantity') != undefined ? $(element).data('quantity') : 1);
			selling_plan = $(element).data('selling_plan');
			do_reload = ($(element).data('reload') != undefined && $(element).data('reload'));
			
			if ($(element).data('item_property') != undefined) {
				let property = $(element).data('item_property').split('|');
				properties[property[0]] = property[1];
			}
			
		} else {
			// all data are attached to parent form (product page case)
			let cartForm = $(element).parents('form');
			variant_id = $(cartForm).find('input[name="id"]').val();
			variant_quantity = $(cartForm).find('input[name="quantity"]').val();
			selling_plan = $(cartForm).find('input[name="selling_plan"]').val();
			
			$(cartForm).find('input[name^="properties"]').each(function () {
				if ($(this).val()) {
					let text = $(this).attr('name');
					let propertyName = text.substr(0,text.length-1).replace("properties[","");
					properties[propertyName] = $(this).val();
				}
			})
		}
		
		$('.shpProcessCartWait').show();		
		$(element).prop('disabled',true);

		jQuery.ajax({
			type: "POST",
			url: "/cart/add.js",
			data: {
				id: variant_id,
				quantity : (variant_quantity = variant_quantity || 1), 
				selling_plan: selling_plan,
				properties: properties,
				sections: 'api-cart_data'
			},
			dataType: "json",
			success: function (success_data) {
				if (do_reload) {
					// if cart should be shown AFTER reload
					sessionStorage.setItem("shpShowCart", true);
					window.location.reload();					
				} else {
					if (Object.hasOwn(success_data, 'sections') && Object.hasOwn(success_data.sections, 'api-cart_data')) {
						shpCustom.shpCartAdditional = JSON.parse($(success_data.sections['api-cart_data']).html());
					}
					shpCustom.getCart();
				}
			},
			error: function (error_data, error_type) {
				shpCustom.cartUpdateError(error_data);
			},
			complete: function () {
				$(element).prop('disabled',false);
				$('.shpProcessCartWait').hide();
			}
		});
	},
		
	cartItemUpdate: function(variant_id, variant_quantity, variant_title) {
	
		//$('.shpProcessCartWait').show();
		
		jQuery.ajax({
			type: "POST",
			url: "/cart/change.js",
			data: {
				id: variant_id,
				quantity: (variant_quantity*1),
			},
			dataType: "json",
			success: function (success_data) {
				if (variant_quantity==0) {
					$('[data-cart-item-vid='+variant_id+']').remove();
				} else if (success_data.items) {
					// check if update succeded
					$.each(success_data.items, function( index, item ) {
						if (variant_id == item.variant_id) {
							if (variant_quantity > item.quantity) {
								shpCustom.showInfo(shpTheme.strings.cartUpdateUnsuccessful, shpTheme.strings.productInventoryLevelTooLow);
							}								
						}
					});
				}
				shpCustom.shpCart = success_data;
				shpCustom.updateCartInfo();
			},
			error: function (error_data, error_type) {
				shpCustom.cartUpdateError(error_data);
			},
			complete: function () {
			}
		});
	},

	cartAttributeUpdate: function(element) {
		let elementValue;
		if (element != undefined && !$(element).data('disable_events')) {
			let elementName = $(element).attr('name');
			let elementForm = $(element).parents('form');
			//console.log(elementForm)
			if ($(element).attr('type') == 'checkbox' || $(element).attr('type') == 'radio') {
				elementValue = $('[name="'+elementName+'"]:checked').val();
			} else {
				elementValue = $('[name="'+elementName+'"]').val();
			}

			let attributes = {};
			$(elementForm).find('[data-cart-attribute]').each(function () {
				let thisName = $(this).attr('name');
				let thisValue;

				if ($(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio') {
					thisValue = $(elementForm).find('[name="'+thisName+'"]:checked').val();
				} else {
					thisValue = $(elementForm).find('[name="'+thisName+'"]').val();
				}
				if (thisValue != undefined && thisValue != "") {
					attributes[$(this).data('cart-attribute')] = thisValue;
				} else {
					attributes[$(this).data('cart-attribute')] = null;
				}

				//console.log([thisName, $(this).attr('type'), $(elementForm).find('[name="'+thisName+'"]:checked'), attributes])
			});
			//console.log(attributes)
			jQuery.post(window.Shopify.routes.root + 'cart/update.js', {attributes}, function(success_data) {
				//console.log(success_data);
				shpCustom.shpCart = success_data;
				shpCustom.updateCartInfo();
			}, 'json');
		}
	},
	
	cartUpdate: function(cart_note, cart_attributes) {
		let data = {'note': null, 'attributes': null};
		
		data['note'] = cart_note;
		data['attributes'] = cart_attributes;
		
		jQuery.ajax({
			type: "POST",
			url: "/cart/update.js",
			data: data,
			dataType: "json",
			success: function (success_data) {
				shpCustom.getCart();
			},
			error: function (error_data, error_type) {
				shpCustom.cartUpdateError(error_data);
			},
			complete: function () {
				$('.shpProcessCartWait').hide();
			}
		});
	},
	
	cartUpdateSuccess: function(success_data, sucess_info) {
	},

	cartUpdateError: function(error_data) {
		let error_info = error_data.responseJSON
		shpCustom.showInfo(error_info.message, error_info.description);
	},
	
	newCartLine: function(item) {
		let newLine = $('.shpCartLineTemplate').clone().insertBefore( $('.shpCartLineTemplate') );
		let moneyFormat = shpTheme.money.moneyFormat+"";
		
		$(newLine).attr('data-cart-item-id',item.product_id);
		$(newLine).attr('data-cart-item-key',item.key);
		$(newLine).attr('data-cart-item-url',item.url);
		$(newLine).attr('data-cart-item-title',item.title);
		$(newLine).attr('data-cart-item-vid',item.variant_id);
		
		$(newLine).find('[data-cart-item-quantity]').attr('data-cart-item-quantity',item.quantity);
		$(newLine).find('input[data-cart-item-quantity]').val(item.quantity);
		
		let imageSize = '115x'
		let newImagePath = item.image.replace(/(.*)\.(.*?)\?v=(.*?)$/, '$1_' + imageSize + '_crop_center.$2?v=$3');		
		$(newLine).find('img[data-cart-item-image]').attr('src',newImagePath);
		
		$(newLine).find('[data-cart-item-url]').attr('href',item.url);
		$(newLine).find('[data-cart-item-title]').html(item.title);
		$(newLine).find('[data-cart-item-product-vendor]').html(item.vendor);
		$(newLine).find('[data-cart-item-product-title]').html(item.product_title);

		// variant options
		if (item.product_has_only_default_variant==false && item.options_with_values) {
			let optionsContainer = $(newLine).find('[data-cart-item-variant_options]');
			if (optionsContainer.length>0) {
				//console.log(optionsContainer.length);
				let optionTemplate = optionsContainer.find('[data-cart-item-variant_option]').detach();
				if (optionTemplate) {
					let newOption;
					jQuery.each(item.options_with_values, function(index, element) {
						newOption = optionTemplate.clone().appendTo(optionsContainer);
						if (optionTemplate.hasClass('short')) {
							let content = element.value
							if (optionsContainer.children('[data-cart-item-variant_option]').length > 1) {
								content = ' / ' + content
							}
							$(newOption).html(content);
						} else {
							$(newOption).html(element.name + ': ' + element.value);
						}
					});
				}
			}
		} else {
			$(newLine).find('[data-cart-item-variant_options]').remove();
		}

		// item line extra properties
		if (item.properties) {
			let propertiesContainer = $(newLine).find('[data-cart-item-properties]');
			if (propertiesContainer.length>0) {
				//console.log(optionsContainer.length);
				let propertyTemplate = propertiesContainer.find('[data-cart-item-property]').detach();
				if (propertyTemplate) {
					let newProperty;
					for (propID in item.properties) {
						newProperty = propertyTemplate.clone().appendTo(propertiesContainer);
						$(newProperty).html(propID + ': ' + item.properties[propID]);
					}
				}
			}
		} else {
			$(newLine).find('[data-cart-item-properties]').remove();
		}

		$(newLine).find('[data-cart-item-quantity_group] [data-type=minus]').on('click', function(event) {
			event.preventDefault();
			shpCustom.setQuantity(this,-1);
		});
		$(newLine).find('[data-cart-item-quantity_group] [data-type=plus]').on('click', function(event) {
			event.preventDefault();
			shpCustom.setQuantity(this,1);
		});
		$(newLine).find('[data-cart-item-quantity_group] [data-type=remove]').on('click', function(event) {
			event.preventDefault();
			shpCustom.cartItemRemove(this);
		});

		// 1. original = regular
		// 2. nie ma jak wdrożyć compare-price, bo nie ma go w danych koszyka
		$(newLine).find('[data-cart-item-original-price]').html(moneyFormat.replace('{{amount}}',numeral(item.original_price/100).format('0,0.00')));
		$(newLine).find('[data-cart-item-regular-price]').html(moneyFormat.replace('{{amount}}',numeral(item.original_price/100).format('0,0.00')));
		$(newLine).find('[data-cart-item-final-price]').html(moneyFormat.replace('{{amount}}',numeral(item.final_price/100).format('0,0.00')));
	
		if (Object.hasOwn(shpCustom.shpCartAdditional, item.variant_id) && Object.keys(shpCustom.shpCartAdditional[item.variant_id])) {
			for (var key in shpCustom.shpCartAdditional[item.variant_id]) {
				$(newLine).find('[' + key + ']').html(shpCustom.shpCartAdditional[item.variant_id][key]);
			}
		}

		$(newLine).removeClass('shpCartLineTemplate');	

		
	},

//-------------------------------------------------------------------------------------------------	
//	other
//-------------------------------------------------------------------------------------------------	
	calculateFS: function () {
		let fsObj = $('[data-free_shipment]');
		let fsObjLevel = $('[data-free_shipment_level]');
		let fsObjCountry = $(fsObjLevel).data('free_shipment_country');
		if (fsObjLevel.data('free_shipment_level') != undefined && fsObjLevel.data('free_shipment_level') > 0 &&
			$('[data-cart-subtotal]').attr('data-cart-subtotal') != undefined && $('[data-cart-subtotal]').attr('data-cart-subtotal')>0) {
			let moneyFormat = shpTheme.money.moneyFormat+"";
			let left_2_free_shipment = fsObjLevel.data('free_shipment_level') - $('[data-cart-subtotal]').attr('data-cart-subtotal');
			
			let info, percentage;
			if (left_2_free_shipment > 0) {
				info = shpTheme.strings.free_shipment_missing+"";
				info = info.replace('{{value}}', moneyFormat.replace('{{amount}}', numeral(left_2_free_shipment).format('0,0.00')));
				percentage = 100 - Math.round(100*(fsObjLevel.data('free_shipment_level') - $('[data-cart-subtotal]').attr('data-cart-subtotal')) / $('[data-cart-subtotal]').attr('data-cart-subtotal'));
			} else {
				info = shpTheme.strings.free_shipment_unlocked+"";
				info = info.replace('{{value}}', moneyFormat.replace('{{amount}}', numeral(fsObjLevel.data('free_shipment_level')).format('0,0.00')));
				percentage = 100
			}
			info = info.replace('{{country}}', fsObjCountry);
			fsObjLevel.html(info);
			$(fsObj).find('.progress').attr('aria-valuenow',percentage)
			$(fsObj).find('.progress-bar').attr('style', 'width:'+percentage+'%')
	} else {
			fsObj.hide();
		}
	},

	initProductGridsVariants: function() {
		if ($('.product-item[data-product_id]').length>0) {
			$('.product-item[data-product_id]').each(function() {
				let product_id = $(this).data('product_id');

				if (window.product_variants[product_id] == undefined) {
					window.product_variants[product_id] = [];
					$(this).find('[data-pvar_vid]').each(function() {
						window.product_variants[product_id].push({
							'variant_id': $(this).data('pvar_vid'),
							'option1': $(this).data('pvar_o1'),
							'option2': $(this).data('pvar_o2'),
							'option3': $(this).data('pvar_o3'),
							'available': $(this).data('pvar_av'),
						});
					});
				}

				if (window.product_variants[product_id]) {
					$('#var-' + product_id + "-1 a.nav-link").each(function() {
						newArray = window.product_variants[product_id].filter( el => 
							el.available == true && 
							el.option1 == $(this).text().trim()
						);
						if (newArray.length == 0) {
							$(this).addClass("disabled")
							$(this).attr("aria-disabled", "true");
							$(this).attr("data-source", "init");
						}
					});
				}
			})
		}

		$('.product-item .add-to-bag:not(.bound-event-001)').addClass('bound-event-001').on('click', function(event) {
			let variable_shown = $(this).parents('.product-item__content').hasClass('variable-show');
			$('.product-item__content').removeClass('variable-show');
			if (!variable_shown) {
				$(this).parents('.product-item__content').addClass('variable-show');
			}
		});
		
		$('.variable-close:not(.bound-event-002)').addClass('bound-event-002').on('click',function() {
			$('.product-item__content').removeClass('variable-show');
			// reset
			shpCustom.resetVariantsSelector($(this).parents('.product-item__variable'));
		});
		// reset selector on mouse leave
		$('.product-item:not(.bound-event-003)').addClass('bound-event-003').on( "mouseleave", function() {
			shpCustom.resetVariantsSelector(this);
		});
		// select variant
		$('.variable li:not(.bound-event-004)').addClass('bound-event-004').on('click',function() {
			shpCustom.selectVariantOption(this)
		});		
	},

	selectVariantOption: function(element) {
		if ($(element).find('.disabled').length == 0) {
			let product_id = $(element).parents('[data-product_id]').data('product_id');
	
			$(element).parents('.variable').addClass('selected');
			$(element).parents('.variable').attr('data-selected', $(element).text().trim());
	
			let vselector_container = $(element).parents('.product-item__variable');
			let filter = {}
			$(vselector_container).find('[data-option]').each(function() {
				if ($(this).attr('data-selected') != '') {
					filter[$(this).data('option')] = $(this).attr('data-selected')
				}
			});
			//console.log(filter);
	
			if ($(element).find('[data-add2bag]').length > 0) {
				selectedVariant = window.product_variants[product_id].filter( el => 
					el.available == true && 
					(filter['option1'] == undefined || el.option1 == filter['option1']) && 
					(filter['option2'] == undefined || el.option2 == filter['option2']) && 
					(filter['option3'] == undefined || el.option3 == filter['option3'])
				);
				// console.log([window.product_variants[product_id], filter, selectedVariant]);
				let variant = selectedVariant.shift();
				if (variant && variant['variant_id']) {
					let add2bagButton = $(element).parents('[data-product_id]').find('button.add-to-bag')
					$(add2bagButton).attr('data-variant_id', variant['variant_id']);
					shpCustom.cartItemAdd(add2bagButton);
				}
				//shpCustom.resetVariantsSelector(vselector_container)
			} else {
				// time to calculate visibility of sub-variants
				let nextVariable = $(element).parents('.variable').next('.variable');
				if (nextVariable.length>0) {
					let nextOption = nextVariable.data('option')
					$(element).parents('.variable').next('.variable').find('a.nav-link').each(function() {
						filter[nextOption] = $(this).text().trim();
						newArray = window.product_variants[product_id].filter( el => 
							el.available == true && 
							(filter['option1'] == undefined || el.option1 == filter['option1']) && 
							(filter['option2'] == undefined || el.option2 == filter['option2']) && 
							(filter['option3'] == undefined || el.option3 == filter['option3'])
						);
						if (newArray.length == 0) {
							$(this).addClass("disabled");
							$(this).attr("aria-disabled", "true");
						}
					});
				}
			}
		}
	},

	resetVariantsSelector: function (element) {
		$(element).find('.variable').removeClass('selected')
		$(element).find('.variable').attr('data-selected','')
		$(element).find('.variable .dynamic-data').removeClass('disabled')
		$(element).find('.variable .dynamic-data').attr('aria-disabled',false)
	},
	
	buildCartRecommended: async function() {
		let inCart = [];
		$('#header-cart [data-cart-item]').each(function() {
			if ($(this).data('cart-item-id')!="") {
				inCart.push($(this).data('cart-item-id'));
			}
		});

		let productData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));
		let recentlyViewed = [];
		if (productData) {
			productData.map(item => {
				if (!inCart.includes(item.productID)) {
					recentlyViewed.unshift(item);
				}
			});
		}

		if (recentlyViewed.length >= 3) {
			let recentlyViewedMaxCount = $('#collapseBag').data('products_count');
			while (recentlyViewed.length > recentlyViewedMaxCount) {
				recentlyViewed.pop();
			}
			let recentlyViewedLoaded = 0;
			$('#header-cart .recommended .product-item[data-source="collection"]').addClass('d-none');
			$.each(recentlyViewed, function(index, element) {
				$.ajax({
					url: shpCustom.baseURL + '/products/' + element.handle + '?sections=product-ajax_grid-item',
					type: 'GET'
				}).done(function(data) {
					$('#collapseBag').append( $(data['product-ajax_grid-item']).html())
				}).always(function() {
					recentlyViewedLoaded = recentlyViewedLoaded + 1;
				});
			});
      while(recentlyViewedLoaded < recentlyViewed.length) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
			window.product_variants = {};
			shpCustom.initProductGridsVariants();
		
		}
	},

	storeRowSizeSelector: function() {
		let rowSizeSelector = {}
		$('#row-size-selector').find('[data-group]').each(function() {
			rowSizeSelector[$(this).attr('id')] = $(this).attr("class")
		})
		sessionStorage.setItem("shpRowSizeSelector",  JSON.stringify(rowSizeSelector));
	},

	isInViewport: function(el) {
    const rect = el.getBoundingClientRect();
		let result = {
			'top': rect.top >= 0,
			'left': rect.left >= 0,
			'bottom': rect.bottom <= (window.innerHeight || document.documentElement.clientHeight),
			'right': rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		};
		//console.log(result, rect);
    return (result.top && result.left && result.bottom && result.right );
	},

	isOverViewport: function(el) {
    const rect = el.getBoundingClientRect();
		let result = {
			'top': rect.top <= 0
		};
		//console.log(result, rect);
    return (result.top);
	}
}

$(document).ready(function() {
	shpCustom.init();

	// Initialize grid layout
	$('.product-grid__default').removeClass('columns-1 columns-2 columns-3 columns-4 columns-5 columns-6');
	
	// First check for user preference in sessionStorage
	if (sessionStorage.getItem("shpRowSizeSelector")) {
		const localData = JSON.parse(sessionStorage.getItem("shpRowSizeSelector"));
		let hasValidSelection = false;
		
		// Check if stored data has a valid selection
		jQuery.each(localData, function(key, value) {
			$('#'+key).attr('class', value);
			if ($('#'+key).hasClass('select')) {
				$('.product-grid__default').addClass('columns-' + key.split('-').pop());
				hasValidSelection = true;
			}
		});
		
		// If no valid selection in stored data, fall back to theme default
		if (!hasValidSelection) {
			// Find which button has 'select' class from theme setting and apply the grid
			$('#row-size-selector button.select[data-group="desktop"]').each(function() {
				let columnCount = $(this).attr('id').split('-').pop();
				$('.product-grid__default').addClass('columns-' + columnCount);
			});
		}
	} else {
		// No user preference, use theme default (find button with 'select' class)
		$('#row-size-selector button.select[data-group="desktop"]').each(function() {
			let columnCount = $(this).attr('id').split('-').pop();
			$('.product-grid__default').addClass('columns-' + columnCount);
		});
	}

	$('[data-country_code_value]').on('click', function(event) {
		event.preventDefault();
		let currentShow = $(this).data('country_code_show')
		let currentValue = $(this).data('country_code_value')
		
		console.log('currency change: [' + currentValue + ' => ' + currentShow + ']')

		$(this).parents('li.nav-item').find('[data-country_code_current_show]').html(currentShow);

		$('#currency-form').find('input[name=country_code]').val(currentValue);
		$('#currency-form').submit();
	});


	window.product_variants = {};
	shpCustom.initProductGridsVariants();

	$('body').on('updateCartInfo', function(event) {
		if ($('body.cart-page').length > 0) {
			window.location.reload();
		} else {
			shpCustom.calculateFS();
			$('.shpCartItemsList [data-cart-item]').each(function() {
				$('#collapseBag .product-item[data-product_id="' + $(this).data('cart-item-id') + '"]').addClass('d-none');
			})

			if (shpCustom.shpCart.items.length >= 2) {
				$('.shpCartContent').addClass('show-arrow');				
			} else {
				$('.shpCartContent').removeClass('show-arrow');				
			}
		}
	}) 
	shpCustom.calculateFS();

	$('body').on('shpShowCart', function(event) {
		if ($('#header-cart').find('.offcanvas-backdrop').length == 0) {
			var cartOffcanvas = new bootstrap.Offcanvas('#offcanvasBag');
			cartOffcanvas.show();
		}
	});

	$('body').on('updateProductInfo updateVariantInfo', function(event) {
		let current_options = {"option1": null, "option2": null, "option3": null};
		$('.product-content__variations.shp-variant_selector input[type=radio][data-option]:checked').each(function() {
			current_options[$(this).data('option')] = $(this).val();
		});
		Object.keys(current_options).forEach(key => {
			let filter = { ...current_options };
			$('.product-content__variations.shp-variant_selector input[type=radio][data-option='+key+']').each(function() {
				filter[key] = $(this).val();
				selectedVariant = shpCustom.shpProduct.variants.filter( el => 
					el.available == true && 
					(filter['option1'] == undefined || el.option1 == filter['option1']) && 
					(filter['option2'] == undefined || el.option2 == filter['option2']) && 
					(filter['option3'] == undefined || el.option3 == filter['option3'])
				);
				if (selectedVariant.length == 0) {
					$(this).addClass('disabled')
				} else {
					$(this).removeClass('disabled')
				}
			});
		});
	});

	$('body').on('updateVariantInfo', function(event) {
		$('#shpInventoryLevelInfo').addClass('d-none');
		let currentVariant = shpCustom.shpProduct.variants[shpCustom.shpProduct.selected_variant_index];
		if (currentVariant.available) {
			$('.shpAdd2CartButton').parents('#product-object').removeClass('variant-unavailable')
		} else {
			$('.shpAdd2CartButton').parents('#product-object').addClass('variant-unavailable')
		}

		$('.shp-variant_selector input[data-option]').each(function() {
			if ($(this).val() == currentVariant[$(this).data('option')] && $(this).prop('checked') == false) {
				$(this).prop('checked',true);
			}
		})

		$.ajax({
			url: $('#product-object').data('baseurl') + '?sections=product-ajax_inventory&variant=' + currentVariant.id,
			type: 'GET'
		}).done(function(data) {
			// 1. load html into page
			let inventoryMessageValue = $(data['product-ajax_inventory']).text().trim()
			if (inventoryMessageValue != "") {
				$('#shpInventoryLevelInfo').html('<span class="product-content__variations_stock_info" >Only ' + inventoryMessageValue + ' left in this ' + $('#shpInventoryLevelInfo').data('option') + '!</span>')
				$('#shpInventoryLevelInfo').removeClass('d-none');
			}
		});

		//console.log('updateVariantInfo');
	})

	$('.product-content__variations.shp-variant_selector input[type=radio]').on('change', function() {
		shpCustom.setNewVariantByOptions($(this).data('option'),$(this).val())
	})

	$('.counter').counterUp();

	$('#play_button').on('click', function () {
		if ($(this).siblings("video").length > 0) {
			var mediaVideo = $(this).siblings("video").get(0);
			if (mediaVideo.paused) {
				mediaVideo.play();
			} else {
				mediaVideo.pause();
			}
		}
	});

	$('.countdown[data-datetime]').each(function() {
		let countdownTimer = $(this);
		let target_date = new Date(countdownTimer.data('datetime')), // set target date
				date = new Date();
		let current_date = new Date(date.getTime() + (date.getTimezoneOffset() * 60000))

		if (target_date - current_date > 0) {
			countdownTimer.removeClass('d-none');
			countdownTimer.downCount({
				date: countdownTimer.data('datetime'),
				offset: 0
			}, function () {
				countdownTimer.addClass('d-none');
			});
		}

	});

	$('body').on('predictiveSearchLoaded', function(event) {
		shpCustom.initProductGridsVariants();
	});



	$( "#rs-layout-1" ).on( "click", function() {
		let dataGroup = $(this).data('group')
		$(this).addClass('select').siblings('[data-group="'+ dataGroup +'"]').removeClass('select');
		$('.product-grid__default').addClass('columns-1').removeClass('columns-2');
		shpCustom.storeRowSizeSelector();
	});
	
	$( "#rs-layout-2" ).on( "click", function() {
		let dataGroup = $(this).data('group')
		$(this).addClass('select').siblings('[data-group="'+ dataGroup +'"]').removeClass('select');
		$('.product-grid__default').addClass('columns-2').removeClass('columns-1');
		shpCustom.storeRowSizeSelector();
	});
	
	$( "#rs-layout-3" ).on( "click", function() {
		let dataGroup = $(this).data('group')
		$(this).addClass('select').siblings('[data-group="'+ dataGroup +'"]').removeClass('select');
		$('.product-grid__default').addClass('columns-3').removeClass('columns-4').removeClass('columns-6');
		shpCustom.storeRowSizeSelector();
	});
	$( "#rs-layout-4" ).on( "click", function() {
		let dataGroup = $(this).data('group')
		$(this).addClass('select').siblings('[data-group="'+ dataGroup +'"]').removeClass('select');
		$('.product-grid__default').removeClass('columns-3').addClass('columns-4').removeClass('columns-6');
		shpCustom.storeRowSizeSelector();
	});
	$( "#rs-layout-6" ).on( "click", function() {
		let dataGroup = $(this).data('group')
		$(this).addClass('select').siblings('[data-group="'+ dataGroup +'"]').removeClass('select');
		$('.product-grid__default').removeClass('columns-3').removeClass('columns-4').addClass('columns-6');
		shpCustom.storeRowSizeSelector();
	});
	
	shpCustom.buildCartRecommended();

	if ($('body.collection-page, body.search-page').length>0) {
		$('body').on('loadItemsList', function() {
			shpCustom.initProductGridsVariants();
			document.addEventListener('scroll', function () {
				let pointer = document.querySelector('[data-load_next_page]');
				if (pointer != null && (shpCustom.isInViewport(pointer) || shpCustom.isOverViewport(pointer))) {
					let nextUrl = $(pointer).data('load_next_page');
					pointer.remove();
					shpCustom.loadItemsList(nextUrl);
					console.log(nextUrl);
				}
			});
		})
		$('body').trigger('loadItemsList');
	}

	// CLASSIC CART
	$('[data-decrease]').on('click', function(event) {
		event.preventDefault();
		let targetField = $('#' + $(this).data('decrease'))
		if (targetField.length>=1) {
			if (targetField.val()*1>0) {
				targetField.val(targetField.val()*1-1);
			}
		}
	});
	$('[data-increase]').on('click', function(event) {
		event.preventDefault();
		let targetField = $('#' + $(this).data('increase'))
		if (targetField.length>=1) {
			targetField.val(targetField.val()*1+1);
		}
	});
	$('[data-proxy4field]').on('change', function(event) {
		event.preventDefault();
		let targetField = $('#' + $(this).data('proxy4field'))
		if (targetField.length>=1) {
			targetField.val($(this).val());
		}
	});

	var offcanvasNavbar = document.getElementById('offcanvasNavbar')
	offcanvasNavbar.addEventListener('hide.bs.offcanvas', function () {
		console.log('hide.bs.offcanvas');
	})
	offcanvasNavbar.addEventListener('hidden.bs.offcanvas', function () {
		console.log('hidden.bs.offcanvas');
		//$('#offcanvasNavbar').find('.nav__sub').addClass('d-none').removeClass('is-active').removeClass('d-none');
	})

});
